import { Badge } from '@/components/badge';
import { Text } from '@/components/text';
import { TruncatedText } from '@/components/ui/truncated-text';
import { ShipmentModel } from '@/lib/models/shipment/types';

type PortProperty = keyof Pick<
  ShipmentModel,
  'originPortCode' | 'originPortName' | 'destinationPortCode' | 'destinationPortName'
>;

interface ShipmentPortNameProps {
  portName: ShipmentModel[PortProperty];
  portCode: ShipmentModel[PortProperty];
  portCodeOnly?: boolean;
}

const ShipmentPortName = ({ portName, portCode, portCodeOnly }: ShipmentPortNameProps) => {
  return portCodeOnly ? (
    <div className="text-baseSm" title={portName || ''}>
      {portCode || '-'}
    </div>
  ) : (
    <span className="flex items-center gap-2">
      <Badge title={portName || ''} variant="bold">
        {portCode}
      </Badge>
      {portName && (
        <Text className="m-0 overflow-hidden truncate leading-tight">
          <TruncatedText content={portName}>{portName}</TruncatedText>
        </Text>
      )}
    </span>
  );
};

export { ShipmentPortName };
